ACC.topnavigation = {
  hamburgerMenuCls: '.ph-hamburger__menu',
  subnavigationCls: '.ph-subnavigation',
  activatedClass: 'ph-activated',
  categorycodeCls: '.ph-headerparent__categorycode',
  currentCategorycode: 'currentCategorycode',
  prepareNavigation: function() {
    ACC.topnavigation.loadSubCategory();
    ACC.topnavigation.bindAll();
    ACC.topnavigation.bindCategoryClick();

    if ($('.ph-page-productList').length > 0 || $('.ph-page-productDetails').length > 0) {
      ACC.breadcrumbs.displayBreadcrumbs();

      if ($('.ph-page-productList .ph-category-breadcrumb > li:last-child').html() === '') {
        $('.ph-page-productList .ph-category-breadcrumb > li:last-child').remove();
      }
    }

    $(document).on('mousedown', '.ph-decisionpage__card a', function() {
      ACC.topnavigation.updateCategoryCode($(this).attr('href'));
    });
    $(document).on('TouchStart', '.ph-decisionpage__card a', function() {
      ACC.topnavigation.updateCategoryCode($(this).attr('href'));
    });

    if ($('.ph-menuitem-gr').length > 0) {
      ACC.topnavigation.gaAnalyticsEvent();
    }
  },
  bindAll: function() {
    $(document).on('click', 'body,html', function(e) {
      if ($(e.target).closest('.ph-main-navigation').length === 0 && $(e.target).closest('.ph-mobilenav-backbutton').length === 0) {
        $(ACC.topnavigation.subnavigationCls).find('.ph-main-navigation > li').removeClass(ACC.topnavigation.activatedClass);
        $('.ph-dropdownnav-close').hide();
        // ACC.topnavigation.toggleBackgroundContent('show');
        $('.ph-menulevel-gr > li').removeClass('ph-clicked_active');
      }
    });
    $(document).on('click', '.ph-dropdownnav-close', function() {
      $('.ph-main-navigation > li').removeClass(ACC.topnavigation.activatedClass);
      $('.ph-dropdownnav-close').hide();
      // ACC.topnavigation.toggleBackgroundContent('show');
      $('.ph-menulevel-gr > li').removeClass('ph-clicked_active');
    });
    $(document).on('click', '.ph-mobilenav-backbutton', function() {
      if ($('.ph-menulevel-ca').children('.ph-activated').length > 0) {
        $('.ph-menulevel-ca').children('.ph-activated').trigger('click');
      } else if ($('.ph-menulevel-gr').children('.ph-activated').length > 0) {
        $('.ph-menulevel-gr').children('.ph-activated').trigger('click');
        $(this).hide();
      }

      ACC.topnavigation.mobileNavTitleChange();
    });
    $(document).on('click', '.ph-headerparent__hamburgermobile,.ph-headerparent__searchiconparentmobile', function() {
      ACC.topnavigation.mobileOpenCurruntlyActive();
    });
  },
  bindCategoryClick: function() {
    $(document).on('click', '.ph-menulevel-gr > li', function(e) {
      if ($(e.target).hasClass('ph-menuitem-gr')) {
        var $currentNode = $(this),
            thirdLevelActiveItem = $(this).find('.ph-slideright-navigation > .ph-currently-active');

        $currentNode.siblings('li').removeClass('ph-activated ph-currently-active');
        $currentNode.toggleClass(ACC.topnavigation.activatedClass);

        if ($currentNode.find('.ph-dropdown-navigation').length === 0) {
          ACC.topnavigation.populateSubmenu($currentNode);
        }

        if (thirdLevelActiveItem.length > 0) {
          thirdLevelActiveItem.parents('.ph-menuitem-ca').addClass('ph-activated ph-currently-active');
          thirdLevelActiveItem.parents('.ph-dropdown-navigation__wrapper').addClass('ph-slideright-active');
        }

        if ($currentNode.hasClass(ACC.topnavigation.activatedClass)) {
          $(ACC.topnavigation.subnavigationCls).find('.ph-dropdownnav-close').show();
          $(ACC.topnavigation.hamburgerMenuCls).find('.ph-mobilenav-backbutton').show();
          // ACC.topnavigation.toggleBackgroundContent('hide');
          $('.ph-menuitem-gr').removeClass('ph-clicked_active');
          $currentNode.addClass('ph-clicked_active');
        } else {
          $(ACC.topnavigation.subnavigationCls).find('.ph-dropdownnav-close').hide();
          $(ACC.topnavigation.hamburgerMenuCls).find('.ph-mobilenav-backbutton').hide();
          // ACC.topnavigation.toggleBackgroundContent('show');
          $currentNode.removeClass('ph-clicked_active');
        }

        ACC.topnavigation.mobileNavTitleChange();
        ACC.topnavigation.topLevelClicked($currentNode);
        ACC.topnavigation.autoClickOneItem($currentNode);
      }
    });

    $(document).on('mouseover', '.ph-menulevel-gr > li', function(e) {
      if ($(e.target).hasClass('ph-menuitem-gr') && $('.ph-headerparent__searchinput:visible').length === 0) {
        var $currentNode = $(this);

        if ($currentNode.find('a').hasClass('ph-inactive-link') && !$currentNode.hasClass('ph-activated')) {
          $('.ph-menulevel-gr > li').removeClass('ph-activated ph-currently-active');
          $currentNode.addClass('ph-activated');
        }

        ACC.topnavigation.autoClickOneItem($currentNode);
      }
    });

    $('.ph-menulevel-gr').on('mouseout', function(e) {
      if ($('.ph-headerparent__searchinput:visible').length === 0) {
        if (e.target.classList.contains('ph-menuitem-gr')) {
          $('.ph-clicked_active').addClass('ph-activated');
          $('.ph-menulevel-gr > li').not('.ph-clicked_active').removeClass('ph-activated ph-currently-active');
        }

        if ($('.ph-dropdown-container:visible').length === 0) {
          $(ACC.topnavigation.subnavigationCls).find('.ph-dropdownnav-close').hide();
        }
      }
    });
    $('.ph-newnavmenubg').on('mouseout', function(e) {
      if ($('.ph-headerparent__searchinput:visible').length === 0) {
        if (e.target.classList.contains('ph-newnavmenubg')) {
          $('.ph-clicked_active').addClass('ph-activated');
          $('.ph-menulevel-gr > li').not('.ph-clicked_active').removeClass('ph-activated ph-currently-active');
        }
      }
    });

    $(document).on('mouseover', '.ph-menulevel-ca > li', function(e) {
      if ($(e.target).hasClass('ph-menuitem-ca') && $('.ph-headerparent__searchinput:visible').length === 0) {
        var $currentNode = $(this);

        if ($currentNode.children('a').hasClass('ph-inactive-link')) {
          $('.ph-menulevel-ca > li').removeClass('ph-activated ph-currently-active');
          $currentNode.parents('.ph-dropdown-navigation__wrapper').removeClass('ph-slideright-active');
          $currentNode.trigger('click');
        }
      }
    });


    $(document).on('click ', '.ph-menulevel-ca > li', function(e) {
      if ($(e.target).hasClass('ph-menuitem-ca')) {
        var $currentNode = $(this);

        $currentNode.siblings('li').removeClass(ACC.topnavigation.activatedClass);
        $currentNode.toggleClass(ACC.topnavigation.activatedClass);

        if ($currentNode.hasClass(ACC.topnavigation.activatedClass)) {
          $currentNode.parents('.ph-dropdown-navigation__wrapper').addClass('ph-slideright-active');
        } else {
          $currentNode.parents('.ph-dropdown-navigation__wrapper').removeClass('ph-slideright-active');
        }

        if ($currentNode.parent().width() > 100) {
          $currentNode.find('.ph-slideright-container').css('left', $currentNode.parent().width());
        }

        ACC.topnavigation.mobileNavTitleChange();
        ACC.topnavigation.subMenuHeightFix($currentNode.parents('.ph-menuitem-gr'));
      }
    });
  },
  subMenuHeightFix: function($currentNode) {
    var $fullwidthNode = $currentNode.find('.ph-fullwidth-bg'),
        decidedHeight = 100,
        visibleHeight = window.innerHeight - 160;

    // $fullwidthNode.css('height', 'auto');

    setTimeout(function() {
      var fullwidthheight = $fullwidthNode.height(),
          sliderightheight = $currentNode.find('.ph-menuitem-ca.ph-activated .ph-slideright-navigation').height();


      if (fullwidthheight < sliderightheight) {
        decidedHeight = sliderightheight + 100;
      } else {
        decidedHeight = fullwidthheight;
      }

      if (visibleHeight < decidedHeight) {
        decidedHeight = visibleHeight;
        $fullwidthNode.addClass('ph-overflowy_scrol');
      } else {
        $fullwidthNode.removeClass('ph-overflowy_scrol');
      }

      $fullwidthNode.height(decidedHeight);
    }, 10);
  },
  mobileNavTitleChange: function() {
    var backtext = $(ACC.topnavigation.subnavigationCls).find('.ph-categorynavigation__backtext').text(),
        navTitleText = $('.ph-menulevel-gr').children('.ph-activated').children('a').text();

    if ($('.ph-menulevel-ca').children('.ph-activated').length > 0) {
      navTitleText = $('.ph-menulevel-ca').children('.ph-activated').children('a').text();
      backtext = $('.ph-menulevel-gr').children('.ph-activated').children('a').text();
    }

    $(ACC.topnavigation.hamburgerMenuCls).find('.ph-menulevel-gr').children('.ph-activated').find('.ph-category-navigation__title').text(navTitleText);
    $(ACC.topnavigation.hamburgerMenuCls).find('.ph-mobilenav-backtext').text(backtext);
  },
  toggleBackgroundContent: function(task) {
    if ($(window).width() > 960) {
      if (task === 'show') {
        $('.ph-container,.ph-footer-full-container').show();
      } else {
        $('.ph-container,.ph-footer-full-container').hide();
      }
    }
  },
  mobileOpenCurruntlyActive: function() {
    var topLevelActiveNode = $('.ph-hamburger__wrapper').find('.ph-menulevel-gr').children('.ph-currently-active');

    if (topLevelActiveNode.length > 0) {
      topLevelActiveNode.trigger('click');
      ACC.topnavigation.mobileNavTitleChange();
    }
  },
  autoClickOneItem: function($currentNode) {
    var $caMenuLi = $currentNode.find('.ph-menulevel-ca .ph-menuitem-ca');

    $caMenuLi.removeClass('ph-activated');

    setTimeout(function() {
      if ($caMenuLi.length === 1 && $caMenuLi.find('.ph-inactive-link').length > 0) {
        $caMenuLi.trigger('click');
      } else {
        ACC.topnavigation.subMenuHeightFix($currentNode);
      }
    }, 10);
  },
  topLevelClicked: function($currentNode) {
    var currentlyActiveNode = $currentNode.find('.ph-menulevel-ca').children('.ph-activated'),
        currentNodeWidth = currentlyActiveNode.parent().width();

    if (currentlyActiveNode.length > 0 && currentNodeWidth > 0) {
      currentlyActiveNode.find('.ph-slideright-container').css('left', currentNodeWidth);
    }

    $('.ph-loggedin-tooltip').addClass('ph-hidden');
    $('.ph-notloggedin-tooltip').addClass('ph-hidden');

    if ($currentNode.find('.ph-menuitem-ca.ph-activated').length > 1) {
      $currentNode.find('.ph-menuitem-ca.ph-currently-active.ph-activated').removeClass(ACC.topnavigation.activatedClass);
    }
  },
  loadSubCategory: function() {
    $('.ph-menulevel-gr > li').each(function() {
      var $currentNode = $(this);

      if ($currentNode.find('.ph-dropdown-navigation').length === 0) {
        ACC.topnavigation.populateSubmenu($currentNode);
      } else {
        $currentNode.children('a').removeClass('ph-inactive-link');
      }

      ACC.topnavigation.activeClassGr($currentNode);
    });

    $('.ph-dropdownnav-close').trigger('click');
  },
  populateSubmenu: function(currentNode) {
    var submenuDataString = $.trim(currentNode.find('.ph-dropdown-container').html()),
        categoryNavigationTitle = currentNode.children('a').text();

    if (submenuDataString === '') {
      currentNode.children('a').removeClass('ph-inactive-link');
    } else {
      var subMenuObject = $.parseJSON(submenuDataString),
          subMenuHtml = '<span class="ph-fullwidth-bg ph-newnavmenubg"><div class="ph-navtitle_container"><h2 class="ph-category-navigation__title">' + categoryNavigationTitle + '</h2></div><div class="ph-dropdown-navigation__wrapper"><ul class="ph-menulevel-ca ph-dropdown-navigation  ph-p-0 ph-m-0" >';

      if (typeof subMenuObject === 'object') {
        currentNode.children('a').addClass('ph-inactive-link');
        subMenuHtml = subMenuHtml + ACC.topnavigation.renderCaMenu(subMenuObject);

        if (subMenuObject.length > 1) {
          subMenuHtml = subMenuHtml + ACC.topnavigation.renderViewAllLink(currentNode);
        }

        subMenuHtml = subMenuHtml + '</ul></div></span>';
        currentNode.find('.ph-dropdown-container').html(subMenuHtml);
      }
    }
  },
  renderCaMenu: function(subMenuObject) {
    var caItems = '',
        activaClassValue = '',
        suLevelItems = '',
        isOneItemClass = 'ph-d-none',
        subMenuObjectCount = subMenuObject.length;

    $.each(subMenuObject, function(i, caMenuItem) {
      if (caMenuItem.subCategories) {
        suLevelItems = ACC.topnavigation.renderSuMenu(caMenuItem);
      }

      if (caMenuItem.subCategories && typeof caMenuItem.subCategories === 'string') {
        var suMenuObject = $.parseJSON(caMenuItem.subCategories);

        if (typeof suMenuObject === 'object' && suMenuObject.length > 1) {
          isOneItemClass = '';
        } else {
          isOneItemClass = 'ph-d-none';
        }
      } else {
        isOneItemClass = 'ph-d-none';
      }

      var inactiveLinkClass = '';

      if (suLevelItems !== '' && isOneItemClass === '') {
        inactiveLinkClass = 'ph-inactive-link';
      }

      activaClassValue = ACC.topnavigation.activeClassSublevel(caMenuItem.identifier);

      if (inactiveLinkClass !== '' && subMenuObjectCount === 1) {
        activaClassValue = 'ph-activated';
      }

      caItems = caItems + '<li class="ph-menuitem-ca ' + activaClassValue + '">\n' +
      '<a class="' + inactiveLinkClass + '" data-identifier="' + caMenuItem.identifier + '"\n' +
      'href="' + ACC.topnavigation.menuURL(caMenuItem.url) + '">' + caMenuItem.name + '</a>\n' +
      '<span class="ph-slideright-container ' + isOneItemClass + ' ">' + suLevelItems + '</span></li>';
    });

    return caItems;
  },
  renderSuMenu: function(caMenuItem) {
    var suItems = '',
        activaClassValue = '',
        suMenuObject = caMenuItem.subCategories;

    if (typeof suMenuObject === 'string') {
      suMenuObject = $.parseJSON(suMenuObject);
    }

    if (typeof suMenuObject === 'object' && suMenuObject.length > 0) {
      suItems = suItems + '<ul class="ph-menulevel-su ph-slideright-navigation  ph-p-0 ph-m-0" >';

      var suCategoryList = $.trim(localStorage.getItem('suCategoryList'));

      $.each(suMenuObject, function(j, suMenuItem) {
        suCategoryList = suCategoryList + ',' + suMenuItem.identifier;
        activaClassValue = ACC.topnavigation.activeClassSublevel(suMenuItem.identifier);
        suItems = suItems + '<li class="ph-menuitem-su ' + activaClassValue + '"><a class="" data-identifier="' + suMenuItem.identifier + '" href="' + ACC.topnavigation.menuURL(suMenuItem.url) + '">' + suMenuItem.name + '</a></li>';
      });

      if (typeof Storage !== 'undefined') {
        localStorage.setItem('suCategoryList', suCategoryList);
      }

      activaClassValue = ACC.topnavigation.activeClassSublevel(caMenuItem.identifier);

      if (suMenuObject.length > 1) {
        var seeAllText = $(ACC.topnavigation.subnavigationCls).find('.ph-categorynavigation__seeall').text();

        suItems = suItems + '<li class="ph-menuitem-su ph-viewall-category ' + activaClassValue + '"><a class="ph-viewall-link" data-identifier="' + caMenuItem.identifier + '" href="' + ACC.topnavigation.menuURL(caMenuItem.url) + '">' + seeAllText + ' ' + caMenuItem.name + '</a></li>';
      }

      suItems = suItems + '</ul>';
    }

    return suItems;
  },
  menuURL: function(urlString) {
    var parsedUrl = urlString.replace('\\u003d', '=');

    return decodeURIComponent(parsedUrl);
  },
  renderViewAllLink: function(currentNode) {
    var categoryUrl = currentNode.children('a').attr('href'),
        categoryName = currentNode.children('a').text(),
        categoryIdentifier = currentNode.children('a').attr('data-identifier'),
        seeAllText = $(ACC.topnavigation.subnavigationCls).find('.ph-categorynavigation__seeall').text();

    return '<li class="ph-menuitem-ca ph-viewall-category "><a class="ph-viewall-link" data-identifier="' + categoryIdentifier + '" href="' + ACC.topnavigation.menuURL(categoryUrl) + '">' + seeAllText + ' ' + categoryName + '</a></li>';
  },
  activeClassGr: function(currentNode) {
    var categoryCode = $.trim($(ACC.topnavigation.categorycodeCls).text()),
        categoryIdentifier = currentNode.children('a').attr('data-identifier'),
        matchingIdentifier = 0,
        activaClassValue = '';

    if (categoryCode !== '' && categoryIdentifier !== '' && categoryCode.indexOf(categoryIdentifier) > -1) {
      matchingIdentifier = 1;
    }

    if (currentNode.find('.ph-currently-active').length > 0) {
      matchingIdentifier = 1;
    }

    if (categoryCode !== '' && (categoryCode === categoryIdentifier || matchingIdentifier === 1)) {
      activaClassValue = 'ph-currently-active ph-highlighted';
      currentNode.addClass(activaClassValue);
    }

    return activaClassValue;
  },
  activeClassSublevel: function(categoryIdentifier) {
    var currentUrl = window.location.toString(),
        categoryCode = $.trim($(ACC.topnavigation.categorycodeCls).text()),
        activaClassValue = '',
        matchingIdentifier = 0;

    if (currentUrl.indexOf('/c/') > -1) {
      categoryCode = currentUrl.split('/c/')[1];
    }

    if (currentUrl.indexOf('?') && currentUrl.indexOf('category:') > -1) {
      categoryCode = currentUrl.split('category:')[1];
    }

    if (categoryCode !== '' && categoryIdentifier !== '' && categoryCode.indexOf(categoryIdentifier) > -1) {
      matchingIdentifier = 1;
    }

    if (categoryCode !== '' && (categoryCode === categoryIdentifier || matchingIdentifier === 1)) {
      activaClassValue = 'ph-currently-active ph-highlighted';
    }

    return activaClassValue;
  },
  updateCategoryCode: function(pageValue) {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem('currentpdp', pageValue);
      localStorage.setItem(ACC.topnavigation.currentCategorycode, $.trim($(ACC.topnavigation.categorycodeCls).text()));
    }
  },
  updatePdpCategoryCode: function() {
    var categoryCode = $(ACC.topnavigation.categorycodeCls).text(),
        currentUrl = window.location.toString();

    if ($.trim($('.ph-product-identifier').text()) !== '') {
      categoryCode = $.trim($('.ph-product-identifier').text());
    }

    if (typeof Storage !== 'undefined' && currentUrl.indexOf($.trim(localStorage.getItem('currentpdp'))) > -1) {
      var storedCategoryCode = $.trim(localStorage.getItem(ACC.topnavigation.currentCategorycode)),
          checkIsSuCategory = ACC.topnavigation.checkIsSuCategory(storedCategoryCode);

      if (storedCategoryCode !== '' && checkIsSuCategory === true) {
        categoryCode = storedCategoryCode;
      }
    }

    if (categoryCode === '') {
      $('.ph-breadcrumb > li > a').each(function() {
        var newcategorylink = '-' + $(this).attr('href');

        if (newcategorylink.indexOf('/c/') > -1) {
          var newcategoryCode = newcategorylink.split('/c/')[1];

          if ($.trim(newcategoryCode) !== '') {
            categoryCode = newcategoryCode;
          }
        }
      });
    }


    $(ACC.topnavigation.categorycodeCls).text(categoryCode);
  },
  ajaxLoadBreadcrumbs: function() {
    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getCatStructure.json',
      dataType: 'json',
      async: true,
      cache: true,
      headers: {
        'Cache-Control': 'max-age=6000'
      },
      success: function(response) {
        if (response) {
          ACC.topnavigation.processAjaxBreadcrumbs(response);
        }
      }
    });
  },
  processAjaxBreadcrumbs: function(catStructureObject) {
    if (typeof catStructureObject === 'object' && catStructureObject.dynamicCategoryData) {
      var phmenuitemgr = 'ph-menuitem-gr';

      $.each(catStructureObject.dynamicCategoryData, function(i, grCategory) {
        if (grCategory.identifier && grCategory.subCategories === '') {
          $('.' + phmenuitemgr + '.' + grCategory.identifier.toLowerCase()).children('a').removeClass('ph-inactive-link');
        } else if (grCategory.identifier && grCategory.subCategories && $('.' + phmenuitemgr + '.' + grCategory.identifier.toLowerCase()).find('.ph-subcat-loaded').length === 0) {
          var subcatHtml = '<span class="ph-dropdown-container ph-subcat-loaded">' + grCategory.subCategories + '</span>';

          $('.' + phmenuitemgr + '.' + grCategory.identifier.toLowerCase()).append(subcatHtml);
        }
      });
      ACC.topnavigation.prepareNavigation();
    }
  },
  checkIsSuCategory: function(storedCategoryCode) {
    var returnable = false;

    if (typeof Storage !== 'undefined') {
      var suCategoryString = $.trim(localStorage.getItem('suCategoryList'));

      if (suCategoryString !== '') {
        var suCategoryArray = suCategoryString.split(',');

        if (suCategoryArray.indexOf(storedCategoryCode) >= 0) {
          returnable = true;
        }
      }
    }

    return returnable;
  },
  trackGaEvent: function($clickedElem, descriptionValue, urlValue) {
    if (window.gaObject && window.eddlEvents && !$clickedElem.hasClass('ph-activated')) {
      var pageValue = '';

      if (window.eddlContext.page && window.eddlContext.page.pageName) {
        pageValue = window.eddlContext.page.pageName;
      } else if (window.eddlContext.page && window.eddlContext.page.pageType) {
        pageValue = window.eddlContext.page.pageType;
      }

      var clickEventInfo = {
        triggerName: 'navigation',
        triggerValue: 'event.navigation',
        eventValue: 'userEvent',
        componentType: 'navigation',
        interaction: {
          goal: 'navigation:category:' + descriptionValue,
          description: String(pageValue) + ':interaction:navigation:category:' + descriptionValue,
          interactive: true
        }
      };

      clickEventInfo.interaction.url = urlValue;

      var eddlAction = window.gaObject.interactionEvent(clickEventInfo);

      window.eddlEvents.push(eddlAction);
      window.ACC.omniture.bindTrackConversion('interaction', 'navigation:category:' + descriptionValue);
    }
  },
  gaAnalyticsEvent: function() {
    var description = '';

    $('.ph-menuitem-gr,.ph-menuitem-ca,.ph-menuitem-su').click(function() {
      var $clickedElem = $(this),
          menuLinkText = description + $clickedElem.children('a').attr('data-identifier');

      ACC.topnavigation.trackGaEvent($clickedElem, menuLinkText, $clickedElem.children('a').attr('href'));
    });
  }
};

window.addEventListener('DOMContentLoaded', function() {
  if ($('.ph-main-navigation').length > 0) {
    if ($('.ph-page-productDetails').length > 0) {
      ACC.topnavigation.updatePdpCategoryCode();
    }

    if (typeof Storage !== 'undefined') {
      localStorage.setItem('suCategoryList', '');
    }

    if ($('.ph-subcat-loaded').length > 0) {
      ACC.topnavigation.prepareNavigation();
    } else {
      ACC.topnavigation.ajaxLoadBreadcrumbs();
    }
  }
});


